import { ContentfulInfoBlock } from "../contentful-info-block/contentful-info-block";
import { Input } from "@angular/core";

export class ContentfulContentRow {    
    entries: ContentfulInfoBlock[]    
}
